export const zhCNAgentGuiProviderIdentity = {
  conversationFilterCodex: "Codex",
  conversationFilterClaudeCode: "Claude Code",
  conversationFilterOpenCode: "OpenCode",
  conversationFilterTutti: "Tutti",
  conversationFilterCursor: "Cursor",
  conversationFilterNexight: "Nexight",
  conversationFilterHermes: "Hermes Agent",
  conversationFilterOpenClaw: "OpenClaw",
  manageAgents: "Agent 栏展示设置",
  manageAgentsTitle: "Agent 栏展示设置",
  manageAgentsDescription:
    "拖拽调整顺序或在可用与停用分组间移动，长按 Agent 可进入编辑。",
  manageAgentsAvailable: "可用 Agent",
  manageAgentsDisabled: "停用 Agent",
  manageAgentsNoAvailable: "可从下方停用列表添加 Agent。",
  manageAgentsNoDisabled: "可以把不希望展示在侧边栏的agent拖到这里",
  manageAgentsKeepOneAvailable: "至少保留一个可用 Agent。",
  manageAgentsRunningBlocked:
    "{{agent}} 正在运行，暂时无法停用。请等待任务结束后再试。",
  removeAgentFromSidebar: "从左侧栏移除 {{agent}}",
  addAgentToSidebar: "将 {{agent}} 添加到左侧栏",
  dragAgentToReorder: "拖拽 {{agent}} 调整顺序"
} as const;
